module.exports = __webpack_public_path__ + "media/flags/ao-18a0fbe0.svg";